import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertCircle, TrendingDown } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set countdown to 30 minutes from now
    const endTime = new Date().getTime() + 30 * 60 * 1000;
    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = endTime - now;
      if (distance < 0) {
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(distance % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.div initial={{
    y: -100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    type: 'spring',
    stiffness: 100,
    damping: 15,
    delay: 0.5
  }} className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-[#B91C1C] via-[#991B1B] to-[#B91C1C] text-[#F4E8D8] shadow-lg border-b-4 border-[#2D241E]" data-id="element-217">
      <div className="max-w-7xl mx-auto px-3 py-1.5" data-id="element-218">
        <div className="flex items-center justify-between gap-2" data-id="element-219">
          {/* Scarcity Message */}
          <div className="flex items-center gap-1.5 text-xs font-sans" data-id="element-220">
            <AlertCircle className="w-3.5 h-3.5 flex-shrink-0 animate-pulse" data-id="element-221" />
            <span className="font-bold" data-id="element-222">OFERTA LIMITADA:</span>
            <span className="hidden sm:inline" data-id="element-223">
              12 cupos al precio promocional
            </span>
            <span className="sm:hidden" data-id="element-224">12 cupos</span>
          </div>

          {/* Countdown Timer */}
          <div className="flex items-center gap-2" data-id="element-225">
            <div className="flex items-center gap-1.5 bg-[#2D241E] px-2.5 py-1 rounded-sm border border-[#F4E8D8]/20" data-id="element-226">
              <Clock className="w-3 h-3 flex-shrink-0 opacity-70" data-id="element-227" />
              <div className="flex items-center gap-1" data-id="element-228">
                <span className="font-serif font-bold text-sm leading-none tabular-nums" data-id="element-229">
                  {String(timeLeft.hours).padStart(2, '0')}
                </span>
                <span className="text-xs opacity-50" data-id="element-230">:</span>
                <span className="font-serif font-bold text-sm leading-none tabular-nums" data-id="element-231">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </span>
                <span className="text-xs opacity-50" data-id="element-232">:</span>
                <span className="font-serif font-bold text-sm leading-none tabular-nums" data-id="element-233">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </span>
              </div>
            </div>

            {/* CTA Button */}
            <button onClick={scrollToPurchase} className="hidden lg:flex items-center gap-1.5 bg-[#1B7A4E] text-[#F4E8D8] px-3 py-1 rounded-sm font-serif font-bold text-xs hover:bg-[#15633F] transition-colors border border-[#15633F]" data-id="element-234">
              <TrendingDown className="w-3 h-3" data-id="element-235" />
              <span data-id="element-236">APROVECHAR</span>
            </button>
          </div>
        </div>
      </div>
    </motion.div>;
}